import { useState, useEffect } from 'react';
import Telegram from './assets/telegram.svg';
import Twitter from './assets/twitter.svg';
import BG from './assets/bg.jpg';


function App() {
  const [password, setPassword] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      document.body.classList.toggle('form-active');
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="harmony-login-wrap">
      <img className="background-image" src={BG} alt="bg" />
      <div className="password-form-wrap">
        <form>
          <label className="" htmlFor="passwordProtector">
            <h1>Password Protector</h1>
            <input
              className="password-field"
              placeholder="Please enter password to access"
              value={password}
              onChange={e => setPassword(e.target.value)}
              type="password"
              name="passwordProtector"
              id="passwordProtector"
              required
            />
          </label>
          <button className="submit-btn" type="submit">Submit</button>
        </form>
        <ul className="social-icon">
          <li><a href="/"><img src={Twitter} alt="Twitter" /></a></li>
          <li><a href="/"><img src={Telegram} alt="Telegram" /></a></li>
        </ul>
      </div>
    </div>
  );
}

export default App;
